import Rollbar from "rollbar";
import { ROLLBAR_CLIENT_TOKEN, ROLLBAR_ENVIRONMENT, CODE_VERSION } from "@config";

export interface LogMetadata {
  endpoint?: string;
  method?: string;
  action?: string;
  subscriptionId?: string;
  paymentMethodId?: string;
}

const rollbar = new Rollbar({
  accessToken: ROLLBAR_CLIENT_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: ROLLBAR_ENVIRONMENT,
  enabled: !!ROLLBAR_CLIENT_TOKEN,
  code_version: CODE_VERSION,
});

export default rollbar;
